import React from 'react'
import AdmBookCategory from '../../components/AdminTabs/AdminBookCategory/AdmBookCategory'

const BookCategory = () => {
  return (
    <div>
        <AdmBookCategory />
    </div>
  )
}

export default BookCategory